import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-exito/autoclave-load-validation-barcelona")({
  head: () => buildRouteHead("/es/casos-de-exito/autoclave-load-validation-barcelona", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/casos-de-exito/validacion-de-una-carga-compleja-de-autoclave-para-mejorar-la-eficiencia-de-la-esterilizacion", replace: true });
  },
});
